export default __webpack_public_path__ + "static/media/hsp.40c6e624.png";